// Client-side mirror of Bot/templateEngine.js's renderTemplate() on the
// server, used only for the dashboard's live preview pane. Keep the
// placeholder list and collapse rules identical to the backend so the
// preview matches what will actually be sent.
const KEYS = [
  "title", "header", "text_preview", "link", "category", "date",
  "title_ar", "header_ar", "text_preview_ar", "category_ar", "link_ar",
  "title_en", "header_en", "text_preview_en", "category_en", "link_en",
];
const PLACEHOLDER_PATTERN = new RegExp(`\\{(${KEYS.join("|")})\\}`, "g");

export const SAMPLE_ARTICLE = {
  title: "Sample headline for the preview",
  header: "A short deck line under the headline",
  text_preview: "This is a preview of the article body, trimmed to the first 200 characters so the message stays short...",
  link: "https://alameennews.net/ar/news/sample-headline",
  category: "Politics",
  date: new Date().toLocaleDateString(),
  title_ar: "عنوان تجريبي للمعاينة",
  header_ar: "سطر فرعي قصير أسفل العنوان",
  text_preview_ar: "هذه معاينة لنص المقال، مقتطعة إلى أول 200 حرف حتى تبقى الرسالة قصيرة...",
  category_ar: "سياسة",
  link_ar: "https://alameennews.net/ar/news/sample-headline",
  title_en: "Sample headline for the preview",
  header_en: "A short deck line under the headline",
  text_preview_en: "This is a preview of the article body, trimmed to the first 200 characters so the message stays short...",
  category_en: "Politics",
  link_en: "https://alameennews.net/en/news/sample-headline",
};

// Substitutes only the whitelisted placeholders (unknown {...} left as-is),
// then collapses any run of blank lines left behind by now-empty values down
// to a single blank line, and trims the result — same as the server. Bold
// markers ("**text**") are deliberately left untouched here: the server
// converts them per-platform (<b> for Telegram, *text* for WhatsApp) for the
// actual outgoing message, but this is a preview pane, so splitBoldSegments
// below renders them as real bold JSX instead.
export function renderTemplatePreview(content, values = SAMPLE_ARTICLE) {
  const substituted = (content || "").replace(PLACEHOLDER_PATTERN, (_, key) => values[key] ?? "");

  const lines = substituted.split("\n").map((line) => line.trim());
  const collapsed = lines.filter((line, i) => line !== "" || lines[i - 1] !== "");

  return collapsed.join("\n").trim();
}

// Splits text on "**bold**" markers (Bot/templateEngine.js's
// BOLD_MARKER_PATTERN) into alternating { text, bold } segments, so the
// preview can render actual bold JSX where the real message will be bold —
// instead of showing the literal double-asterisks.
export function splitBoldSegments(text) {
  const pattern = /\*\*([\s\S]+?)\*\*/g;
  const parts = [];
  let lastIndex = 0;
  let match;
  while ((match = pattern.exec(text)) !== null) {
    if (match.index > lastIndex) parts.push({ text: text.slice(lastIndex, match.index), bold: false });
    parts.push({ text: match[1], bold: true });
    lastIndex = pattern.lastIndex;
  }
  if (lastIndex < text.length) parts.push({ text: text.slice(lastIndex), bold: false });
  return parts;
}
